import '../styles/Introduction.scss';

import { Stack } from '@whistler-ui/k2/components/Stack';
import { Heading, Paragraph } from '@whistler-ui/k2/components/Typography';
import { useClassHelper } from '@whistler-ui/k2/hooks';

import { useRenderIf } from '../../../hooks/useRenderIf';
import { useThemeStore } from '../../../store/theme';

const componentName = 'c-Introduction';

export function Introduction() {
  const c = useClassHelper(componentName);
  const { config } = useThemeStore();
  const { isCSG, isGD, isNL, isGSMA } = useRenderIf();

  // Image builder for each Partner
  const renderImage = () => {
    if (isCSG || isGSMA) {
      if (!config.assets.onboarding.dashboardIntro1) {
        return null;
      }

      return (
        <figure className={c('__single-image')}>
          <img
            src={config.assets.onboarding.dashboardIntro1}
            alt="onboarding"
          />
        </figure>
      );
    }

    if (isNL || isGD) {
      if (!config.assets.onboarding.dashboardIntro1) {
        return null;
      }

      return (
        <Stack direction="column">
          <img src={config.assets.onboarding.dashboardIntro1} alt="usecase 1" />
          <img
            src={config.assets.onboarding.dashboardIntro2}
            alt="use case 2"
          />
        </Stack>
      );
    }

    return null;
  };

  return (
    <Stack
      tag="article"
      direction="row"
      gap={isCSG ? 8 : 4}
      className={c('base')}
    >
      <Stack direction="column" gap={8}>
        <Heading>What is an Entitlement Server?</Heading>
        <Stack direction="column" gap={4}>
          <Paragraph>
            An Entitlement Server (ES) is a key piece of technology that ensures
            a great user experience for your customers as they use various
            services on their mobile devices.
          </Paragraph>
          <Paragraph>
            These include registering for OEM features like iMessage/FaceTime,
            setting up Wi-Fi Calling or managing eSIM-related procedures like
            device provisioning and transfer.
          </Paragraph>
          <Paragraph>
            {config.i18n.variables.productName} is different to traditional
            solutions in that it operates in the cloud as an ISO/IEC 27001
            certified multi-tenant Platform as a Service (PaaS). Each carrier
            has their own tenancy which makes for rapid deployment and ease of
            in-life management.
          </Paragraph>
        </Stack>
      </Stack>
      <aside className={c({ '--big-sidebar': isCSG })}>{renderImage()}</aside>
    </Stack>
  );
}
